/**
 * Shared tokenizer + stem-overlap matcher used by policies and alignment.
 * Deliberately conservative to avoid false-positive constraint rejections.
 */

const STOPWORDS = new Set([
  "the", "a", "an", "and", "or", "for", "of", "to", "in", "on", "with",
  "at", "by", "from", "is", "are", "how", "what", "best", "top", "near",
  "me", "my", "your", "you", "buy", "get", "shop", "new", "our", "we",
  "have", "has", "had", "not", "no", "yes", "any", "all", "some",
  "back", "front", "side", "over", "under", "into", "out", "off", "up",
  "down", "than", "then", "them", "they", "their", "there", "here",
  "this", "that", "these", "those", "who", "whom", "which", "why",
  "when", "where", "much", "many", "more", "less", "few", "one", "two",
  "three", "own", "just", "very", "really", "also", "still", "only",
  "small", "large", "big", "limited", "capacity", "team", "hire", "staff",
  "time", "produce", "protective", "brand", "reputation", "service",
  "services", "trust", "community", "customer", "customers", "local",
  "locals", "grow", "growing", "revenue", "attract", "attracted",
  "campaign", "campaigns", "wasted", "reduce", "spend", "budget",
  "planning", "ahead", "high", "low", "margin", "niche", "niches",
  "assortment", "based", "existing", "engaged", "audience", "online",
  "content", "weekly", "occasion", "occasions", "right", "curated",
  "selection", "personal", "including", "aligned", "featured",
  "recognized", "market",
]);

/** Tokenize, drop stopwords, drop tokens shorter than 4 chars, and stem. */
export function stems(input: string): Set<string> {
  const raw = input
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .split(/\s+/)
    .filter((t) => t.length >= 4 && !STOPWORDS.has(t));
  const out = new Set<string>();
  for (const t of raw) out.add(t.replace(/(ies|es|s|ing|ed)$/g, ""));
  return out;
}

/** True if `a` and `b` share at least one non-trivial stem. */
export function shareStem(a: string, b: string): boolean {
  const A = stems(a);
  const B = stems(b);
  for (const s of A) if (B.has(s)) return true;
  return false;
}